<template>
  <l-checkbox
    v-model="model"
    name="national"
    help="High-prestige jobs include associate positions at America's largest firms, federal clerkships, and competitive public service positions."
    label="Working in a high-prestige job is very important to me"
  />
</template>

<script setup>
import LCheckbox from "@/components/inputs/LCheckbox.vue"

const model = defineModel([Number, Boolean])
</script>
